<dx-date-box
  type="time"
  #dateInput
  [attr.name]="nameString"
  [attr.tabindex]="tabIndexValue"
  class="focusable"
  [(value)]="time"
  (ngModelChange)="changeModelState()"
  (blur)="onblurEvent()"
  [required]="requiredValue"
  [readonly]="disabledValue"
  [min]="minValue"
  openOnFieldClick="true"
  (onFocusOut)="onblurEvent()"
  (onFocusIn)="onFocusIn()"
  (onInitialized)="onInitialized.emit($event)"
  [disabled]="disabledValue">
</dx-date-box>
     
